<template>
  <StepItem
    format="splash"
    title="Welcome to Business Draft"
    subtitle="You've taken the first step towards effortlessly finding your dream candidates. Let's match you with top-notch talent, tailored just for your business."
    @handle-next-step="handleNextStep"
    :is-ready-for-next-step="true"
  >
    <template v-slot:next-step-text>Explore Dashboard</template>
    <template v-slot:splash-image>
      <AnimationCelebrate/>
    </template>
  </StepItem>
</template>

<script setup>
import AnimationCelebrate from "./AnimationCelebrate.vue";
import StepItem from "./StepItem.vue";
import {useRouter} from "vue-router";
import {useAccountStore} from "../stores/AccountStore.js";

const router = useRouter();
const accountStore = useAccountStore();
const handleNextStep = () => {
  accountStore.fetchUserAccount();
  router.push({path: "/company-dashboard"});
};
</script>
